import { all } from "redux-saga/effects";

//public
import AuthSaga from "./auth/login/saga";

import ProfileSaga from "./auth/profile/saga";
import LayoutSaga from "./layout/saga";

// Users
import AddUserSaga from "./users/saga";

// Items
import ItemSaga from "./items/saga";

// Equipments
import EquipmentSaga from "./equipments/saga";


export default function* rootSaga() {
  yield all([
    //public
    AuthSaga(),
    ProfileSaga(),
    LayoutSaga(),
    AddUserSaga(),

    ItemSaga(),
    EquipmentSaga(),
  ]);
}
